import styled from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

export const PreviewTitle = styled(Text)`
  text-transform: uppercase;
  letter-spacing: 0.6px;
`

export const PreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp16};
  background-color: ${props => props.theme.colors.background.secondary};
  border-radius: ${props => props.theme.spacing.sp8};
`

export const StepRow = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp12};
  align-items: center;
`

export const StepNumber = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: ${props => props.theme.size.XS};
  height: ${props => props.theme.size.XS};
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.default};
  color: ${props => props.theme.colors.text.default};
  border-radius: ${props => props.theme.primitives.radius.radiusFull};
  font-size: ${props => props.theme.texts.bodySRegular.fontSize};
`

export const StepContent = styled.div`
  flex: 1;
  min-width: 0;
  overflow-wrap: break-word;

  p {
    margin: 0;
  }

  a {
    color: ${props => props.theme.colors.success.default};
  }
`
